import { render, staticRenderFns } from "./UnKnowPage.vue?vue&type=template&id=6f3c8298&scoped=true&"
import script from "./UnKnowPage.vue?vue&type=script&lang=js&"
export * from "./UnKnowPage.vue?vue&type=script&lang=js&"
import style0 from "./UnKnowPage.vue?vue&type=style&index=0&id=6f3c8298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c8298",
  null
  
)

export default component.exports